import { useCore } from '../../core';

export function useHeaderTag(level: 1 | 2 | 3 | 4): React.ElementType<React.HTMLAttributes<HTMLElement>> {
    const {
        hostConfig: { initialHeadingLevel },
    } = useCore();

    return `h${initialHeadingLevel + level - 1}` as React.ElementType<React.HTMLAttributes<HTMLElement>>;
}
